import React, { Component } from 'react'
import { observable, makeObservable, action } from 'mobx'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'

import NavigationTabs from './components/NavigationTabs'
import NewNavigationTabs from './components/NewNavigationTabs'
import PublishBanner from './components/PublishBanner'
import SurveyWizard from '../SurveyWizardNew'
import Builder from './Builderv4'
import PresentationV2 from '../PresentationV2'
import Certification from '../Certification'
import Report from '../ReportV2'
import Preview from '../Preview/Preview'
import AppLoading from '../AppLoading'
import Print from './Print'
import DistributionLandingScreen from '../Distribute/DistributionLandingScreen'
import EmailBuilder from '../Distribute/EmailBuilder'
import CampaignLinks from '../Distribute/CampaignLinks'
import WebsiteEmbed from '../Distribute/WebsiteEmbed'
import WebsiteIntercept from '../Distribute/WebsiteIntercept'
import QrCode from '../Distribute/QrCode'
import AccessRights from '../AccessRights'
import RouteNotAllowed from '../RouteNotAllowed'
import EmDistribute from '../EmDistribute'
import { Survey as asdf } from '../../Models/Survey'
import DynamicDashboard from '../DynamicDash'
import { allowedTemplateIndustries } from '../SurveyWizardNew/constants'

import Settings from '../SurveyBuilderSettings'
import OnSiteApp from '../Distribute/OnSiteApp'

const userRoles = {
    SUPER_USER: 100,
    MASTER_USER: 110,
    DIVISION_USER: 120,
    PORTFOLIO_USER: 130,
    PRODUCT_USER: 140,
    DIRECTOR_USER: 150,
    REPORT_USER: 170,
}

@observer
export default class Survey extends Component {
    @observable surveyState

    isTemplate = false

    hasCertification = false

    constructor(props) {
        super(props)
        makeObservable(this)
        this.surveyState = 'loading'
    }

    @action
    async componentWillReceiveProps(props) {
        const { store } = this.props
        const { survey } = store
        console.log(`componentWillReceiveProps ${store.surveyTab}, ${store.reloadPage}`)
        if (props.match.params.tab !== store.surveyTab || store.reloadPage) {
            console.log('update')
            store.surveyTab = props.match.params.tab
            this.prevState = this.surveyState
            this.surveyState = 'loading'
            const surveyState = props.match.params.tab || 'edit'
            if (['campaign', 'email', 'distribute'].indexOf(surveyState) > -1) {
                const distributeOptions = await store.http.get(`/survey/${survey.id}/distributeoptions`)
                store.distributeOptions = distributeOptions.map(((option) => option.a))
            }
            this.surveyState = surveyState
            if (this.surveyState === 'print') {
                document.title = store.survey.title
            } else {
                document.title = 'explori - survey'
            }
        }
    }

    getLatestUI = async (surveyId) => {
        const { store } = this.props
        const { survey } = store
        const result = {
            show: false,
            use: false,
        }

        try {
            const response = await store.http.get(`/survey/${surveyId}/latestui`, store.surveyToken)
            result.show = true
            result.use = response.uselatestui
        } catch (e) {
            console.log('Error getting latest UI config')
        }
        return result
    }

    async componentDidMount() {
        const {
            store, match, history, distributeStore,
        } = this.props

        store.surveyTab = match.params.tab
        const surveyId = match.params.id
        store.clientIndustries = await store.http.get('/industries')
        const distributeOptions = await store.http.get(`/survey/${surveyId}/distributeoptions`)
        store.distributeOptions = distributeOptions.map(((option) => option.a))
        store.useLatestUI = 1
        this.prevState = this.surveyState

        if (surveyId === '0') {
            const params = new URLSearchParams(location.search)
            const cannotCreateNewSurvey = store.tokenData.roles.match(new RegExp(`${userRoles.DIRECTOR_USER}|${userRoles.REPORT_USER}`))
            const cannotCreateNewTemplate = params.get('surveytype') === 'T' && (
                !process.env.NEW_TEMPLATING || !store.tokenData.roles.match(new RegExp(`${userRoles.SUPER_USER}|${userRoles.MASTER_USER}`))
            )
            const invalidTemplateIndustry = params.get('surveytype') === 'T' 
                && !allowedTemplateIndustries.includes(window.location.pathname.split('/')[3])
            if (cannotCreateNewSurvey || cannotCreateNewTemplate || invalidTemplateIndustry) {
                location.href = '/home/e/0106'
                return
            }
            const industry = store.clientIndustries.length === 1 ? store.clientIndustries[0] : match.params.tab
            console.log(`tab ${match.params.tab}`)
            console.log(store.clientIndustries)
            if (store.clientIndustries.indexOf(industry) > -1) {
                store.survey = new asdf({
                    content: {},
                    pages: [],
                    metadata: {
                        clientId: store.tokenData.clientId,
                        locales: [],
                        productInfo: {
                            industrySpecificInfo: {
                                industry,
                            },
                        },
                        taxonomy: {},
                        creationInfo: {
                            createdBy: store.tokenData.userId,
                        },
                        adminConsole: {},
                        displaySettings: {},
                    },
                    skipLogic: [],
                })
                this.surveyState = 'newSurvey'
            } else {
                this.surveyState = 'invalidIndustry'
            }
        } else {
            store.resetLicenceAllowance()
            const surveyToken = await store.http.get(`/${match.params.id}/surveyToken`)
            store.surveyToken = surveyToken.token
            this.useLatestUI = await this.getLatestUI(surveyId)
            try {
                const surveyTokenDetail = JSON.parse(atob(store.surveyToken.split('.')[1]))
                if (surveyTokenDetail.surveyAuth[1] === 0) {
                    location.href = '/'
                    return
                }
                this.reportAccess = surveyTokenDetail.reportAccess
            } catch (e) {
                this.reportAccess = false
            }
            store.surveyAuthLevel = JSON.parse(atob(store.surveyToken.split('.')[1])).surveyAuth
            if (store.tokenData.roles.match(new RegExp(`${userRoles.DIRECTOR_USER}|${userRoles.REPORT_USER}`))) {
                store.surveyAuthLevel[1] = 2
            }
            // console.log(`surveyAuthLevel ${store.surveyAuthLevel[1]}`)

            try {            
                const response = await store.http.get(`/api/survey/${match.params.id}`, store.surveyToken)
                const { isCertificationEnabled } = R.pathOr(false, ['userData', 'flags'], store)
                const certifications = isCertificationEnabled ? await store.http.get(`/certification/certify/${match.params.id}`) : []
                this.hasCertification = certifications.length > 0

                store.survey = new asdf(response)
                const surveymetadata = store.survey?.metadata
                if (surveymetadata) {
                    const prodResponse = await store.http.get(`/product/${surveymetadata.productInfo.productId}`, store.surveyToken)
                    let templateResponse = undefined
                    store.survey.metadata.productInfo.status = prodResponse[0]?.status
                    store.isTemplatePublished = R.pathOr(false, 'isTemplatePublished', surveymetadata)
                    if (prodResponse[0]?.status === 5){
                        store.isTemplate = true
                        if (surveymetadata.taxonomy.surveyType === 'EM' && !store.isExploriAdmin()) {
                            this.surveyState = 'error'
                            return
                        }
                    } else {
                        // some templates are linked to an explori Product, 
                        // which won't return in `/product/${productId}` if logged user's clientId is not 1
                        templateResponse = await store.http.get(`/template/product`, store.surveyToken)
                        if (templateResponse.some((i) => i.productId === surveymetadata.productInfo.productId)) {
                            store.isTemplate = true
                            store.survey.metadata.productInfo.status = 5
                        } else store.isTemplate = false
                    }
                    const breadcrumbs = [
                        {
                            url: store.survey.isMaxbi() ? '/maxbi' : store.isTemplate ? '/survey-templates' : '/survey',
                            title: store.survey.isMaxbi() ? 'Maxbi' : store.isTemplate ? 'Template' : 'Survey',
                        },
                        {
                            name: 'productTitle',
                            url: `/event/?productId=${prodResponse[0]?.productId}`,
                            title: prodResponse[0]?.productName,
                        },
                        {
                            name: 'surveyTitle',
                            url: `/survey/${store.survey.id}`,
                            title: store.survey.title,
                        },
                    ]
                    if (store.isTemplate) breadcrumbs.splice(1,1) // remove product title if template
                    store.breadcrumps = breadcrumbs
                }
                try {
                    const { productId } = store.survey.metadata.productInfo
                    const { clientId } = store.survey.metadata
                    const [productLocales] = await Promise.all([
                        store.http.get(`/product/${productId}/langs`),
                        store.setLicenceAllowance(clientId, productId),
                    ])
                    productLocales.map((loc) => {
                        store.productLocales[loc.locale] = loc.value
                    })
                    store.updateBreadcrump('productTitle', store.survey.getProductName(store.productLocales))
                } catch (e) {
                    store.productLocales = {
                        default: store.survey.getProductName({}),
                    }
                }

                const { taxonomy, productInfo } = store.survey.metadata
                const { surveyType, respondentType } = taxonomy
                const { industrySpecificInfo } = productInfo
                const { productType, industry } = industrySpecificInfo

                const portfolioDetails = await store.http.get(`/portfolioid?productId=${store.survey.metadata.productInfo.productId}`)

                if (process.env.USE_NEW_KPIS) {
                    try {
                        store.surveyKpis = await store.http.get(`/kpi?industry=${industry}&productType=${productType}&surveyType=${surveyType}&respondentType=${respondentType}`)
                    } catch (e) {
                        console.log(e)
                        store.surveyKpis = []
                    }
                } else {
                    store.surveyKpis = [
                        {
                            kpiId: 'OAS',
                            name: 'Objective Success Score',
                        },
                        {
                            kpiId: 'ST',
                            name: 'Strategy',
                        },
                        {
                            kpiId: 'EV',
                            name: 'Event',
                        },
                        {
                            kpiId: 'LS',
                            name: 'Lead Success',
                        },
                        {
                            kpiId: 'OV',
                            name: 'Maxbi (Overall)',
                        },
                    ]
                }

                store.survey.portfolioId = portfolioDetails.portfolioId
                store.survey.portfolioName = portfolioDetails.portfolioName
                store.survey.divisionId = portfolioDetails.divisionId
                // console.log(JSON.stringify(store.survey, null, 4))
                // console.log(response)
                const { noOfResponses } = await store.http.get(`/${surveyId}/numberofresponses`)
                store.noOfResponses = noOfResponses
                try {
                    const {
                        hascampaign, hasOnSite, hasIntercept, hasEmbed, hasQR,
                    } = await store.http.get(`/survey/${surveyId}/hascampaign`, store.surveyToken)
                    store.hascampaign = hascampaign
                    store.hasOnSite = hasOnSite
                    store.hasIntercept = hasIntercept
                    store.hasEmbed = hasEmbed
                    store.hasQR = hasQR
                } catch (e) {}
                const yrOnYrSurveys = await store.http.get(`/survey/${store.survey.id}/yoysurveys/${store.survey.metadata.taxonomy.surveyType}/${store.survey.metadata.taxonomy.respondentType}`)
                // console.log(JSON.stringify(yrOnYrSurveys, null, 4))
                store.lastYearSurveys = [
                    {
                        label: i18n.t('form.general.please_select_ellipsis'),
                        value: '00000000-0000-0000-0000-000000000000',
                    }, ...yrOnYrSurveys.map((yrOnYr) => (
                        {
                            label: yrOnYr.name,
                            value: yrOnYr.surveyId,
                            year: yrOnYr.year,
                        }
                    )),
                ]
                await this.getRecommendedMandatoryQuestions()
                if (store.surveyTab === 'setupOrReport') {
                    if (store.noOfResponses === 0 && store.survey.metadata.status.name !== 'Closed') {
                        history.push(`/survey/${surveyId}/setup`)
                    } else {
                        store.goTo('report', null, surveyId)
                    }
                } else {
                    this.surveyState = match.params.tab || 'edit'
                    if (this.surveyState === 'print') {
                        document.title = store.survey.title
                    }
                }
            } catch (e) {
                console.log('error')
                console.error(e)
                if (e.status === 403) {
                    location.href = '/home/e/0106.1'
                    return
                } if (e.name === 'AbortError') {
                    // console.log('timeout')
                }
                this.surveyState = 'error'
            }
        }
        await distributeStore.getEmailData()
    }

    componentWillUnmount() {
        const { store } = this.props
        Reflect.deleteProperty(store, 'mandatoryQuestions')
    }

    getRecommendedMandatoryQuestions = async () => {
        const { store } = this.props
        const { survey } = store
        if (!survey.portfolioId) return

        let url = '/qlist/getQlists2'
        url += `?recordId=${survey.portfolioId}`
        url += '&oid=5'
        url += `&productType=${survey.metadata.productInfo.industrySpecificInfo.productType}`
        url += `&respondentType=${survey.metadata.taxonomy.respondentType}`
        url += `&surveyType=${survey.metadata.taxonomy.surveyType}`
        url += `&industry=${survey.metadata.productInfo.industrySpecificInfo.industry}`
        url += '&history=1'
        url += '&cols=full'
        url += '&orderby=priority'
        url += '&filter='

        try {
            const questions = await store.http.get(url)
            const recommendedQuestions = []
            const mandatoryQuestions = questions.filter((q) => {
                if (q.isRecommended) recommendedQuestions.push(q)
                return !q.isRecommended
            })
            store.mandatoryQuestions = mandatoryQuestions
            store.recommendedQuestions = recommendedQuestions
        } catch (e) {
            console.error(e)
            store.mandatoryQuestions = []
            store.recommendedQuestions = []
        }
    }

    presentationAccess = async (deniedRedirect) => {
        const { store } = this.props
        if (
            store.surveyAuthLevel[1] === 0
            || !store.userData.flags.pptLevel
        ) {
            location.href = deniedRedirect
        }
    }

    hasReportAccess = () => this.reportAccess

    printAccess = async (deniedRedirect) => {
        const { store } = this.props
        const { survey } = store
        if (survey.metadata.clientId !== 1 && store.surveyAuthLevel[1] < 6) {
            location.href = deniedRedirect
        } else if (survey.metadata.clientId === 1 && !store.isTemplate) {
            location.href = deniedRedirect
        }
    }

    customerJounreyIsEnabled = () => {
        const { journeyId } = this.props.store.survey.metadata.productInfo.industrySpecificInfo

        return !!(journeyId)
    }

    render() {
        const {
            store, match, history, distributeStore,
        } = this.props
        const { survey } = store
        let component = null
        const surveyTabsMenu = process.env.USE_NEW_HEADER_UI
            ? (<NewNavigationTabs store={store} activeTab={match.params.tab} history={history} showCertification={this.hasCertification} />)
            : (<NavigationTabs store={store} activeTab={match.params.tab} history={history} showCertification={this.hasCertification} />)
        switch (this.surveyState) {
            case 'error':
                component = <AppLoading text="Error loading survey" hideLoader />
                break
            case 'accessDenied':
                component = <AppLoading text="Access Denied!" hideLoader />
                break
            case 'loading':
                component = <AppLoading text="Loading" />
                break
            case 'invalidIndustry':
                component = (
                    <div className="notFound">
                        <i className="fas fa-ban" />
                        {' '}
                        Invalid industry
                    </div>
                )
                break
            case 'newSurvey':
                component = <SurveyWizard appStore={store} history={history} />
                break
            case 'setup':
                if (store.surveyAuthLevel[1] < 6) {
                    location.href = '/home/e/0106.1'
                    return <div />
                }
                component = []
                if (store.isTemplate && process.env.NEW_TEMPLATING && !process.env.USE_NEW_HEADER_UI) component.push([<PublishBanner store={store} />])
                component.push([surveyTabsMenu])

                if (survey.metadata.taxonomy.surveyType === 'EM' && !store.isTemplate) {
                    component.push(<EmDistribute store={store} surveyId={match.params.id} history={history} />)
                } else {
                    component.push(
                        <Builder
                            store={store}
                            surveyId={match.params.id}
                            history={history}
                            showCertification={this.hasCertification && !store.isTemplate}
                        />,
                    )
                }
                break
            case 'user': case 'campaign': case 'email': case 'onsite': case 'embed': case 'intercept': case 'qr': case 'distribute':
                if (store.surveyAuthLevel[1] < 6 || R.pathOr(false, ['userData', 'flags', 'isDistributedDisabled'], store)) {
                    location.href = '/home/e/0106.1'
                    return <div />
                }
                if (store.isTemplate) {
                    component = [
                        surveyTabsMenu,
                        <RouteNotAllowed store={store} surveyId={match.params.id} history={history} />,
                    ]
                } else if (survey.metadata.taxonomy.surveyType === 'EM') {
                    component = [
                        surveyTabsMenu,
                        <EmDistribute store={store} surveyId={match.params.id} history={history} />,
                    ]
                } else {
                    const surveyQuestions = survey.pages
                        .map((p) => (p.questions && p.questions.length ? p.questions.slice() : undefined))
                        .flat(2)

                    const noMissingSGOptions = surveyQuestions.every((q) => {
                        if (R.pathOr('', ['question', 'questionTypeCode'], q) !== 'SG') return true

                        return q.question.questionTypeCode === 'SG'
                        && (R.pathOr([], ['optionSetY', 'options'], q).length)
                    })

                    if (store.hasMandatoryQuestions() || !noMissingSGOptions) {
                        history.push(`/survey/${survey.id}/setup`)
                    }

                    component = [surveyTabsMenu]

                    const wasInDistributeState = ['campaign', 'onsite', 'distribute', 'email', 'embed', 'intercept', 'qr', 'loading'].indexOf(this.prevState) > -1

                    if (!wasInDistributeState && store.distributeOptions.length > 0) {
                        if (this.surveyState === 'distribute') {
                            if (store.distributeOptions.includes('hasSurveyUser') || store.distributeOptions.includes('hasSchedule')) {
                                history.push(`/survey/${survey.id}/email`)
                            } else if (store.distributeOptions.includes('hasCampaign')) {
                                history.push(`/survey/${survey.id}/campaign`)
                            }
                        } else if (this.surveyState === 'email' && (store.distributeOptions.includes('hasSurveyUser') || store.distributeOptions.includes('hasSchedule'))) {
                            history.push(`/survey/${survey.id}/email`)
                        } else if (this.surveyState === 'campaign' && store.distributeOptions.includes('hasCampaign')) {
                            history.push(`/survey/${survey.id}/campaign`)
                        } else if (this.surveyState === 'onsite' && store.distributeOptions.includes('hasCampaign')) {
                            history.push(`/survey/${survey.id}/onsite`)
                        }
                    } else if (!wasInDistributeState && this.surveyState !== 'distribute' && !store.distributeOptions.length) {
                        history.push(`/survey/${survey.id}/distribute`)
                    } else if (!wasInDistributeState && !store.distributeOptions.length) {
                        component.push(<DistributionLandingScreen store={store} distributeStore={distributeStore} match={match} />)
                    } else if (wasInDistributeState) {
                        if (this.surveyState === 'onsite') {
                            component.push(<OnSiteApp store={store} distributeStore={distributeStore} match={match} history={history} />)
                        } else if (this.surveyState === 'embed') {
                            component.push(<WebsiteEmbed store={store} distributeStore={distributeStore} match={match} history={history} />)
                        } else if (this.surveyState === 'intercept') {
                            component.push(<WebsiteIntercept store={store} distributeStore={distributeStore} match={match} history={history} />)
                        } else if (this.surveyState === 'qr') {
                            component.push(<QrCode store={store} distributeStore={distributeStore} match={match} history={history} />)
                        } else if (this.surveyState === 'campaign') {
                            component.push(<CampaignLinks campaignType={this.surveyState} onSite={this.surveyState === 'onsite'} store={store} distributeStore={distributeStore} match={match} history={history} />)
                        } else if (this.surveyState === 'email') {
                            component.push(<EmailBuilder store={store} distributeStore={distributeStore} match={match} history={history} tab={store.distributeOptions.includes('hasSchedule') ? 'builder' : store.distributeOptions.includes('hasSurveyUser') ? 'lists' : 'builder'} />)
                        } else {
                            console.log('wasInDistributeState && ! surveyState match')
                            history.push(`/survey/${survey.id}/email`)
                        }
                    } else if (this.surveyState === 'email') {
                        component.push(<EmailBuilder store={store} distributeStore={distributeStore} match={match} history={history} tab={store.distributeOptions.includes('hasSurveyUser') ? 'lists' : 'builder'} />)
                    } else {
                        console.log('last else')
                        history.push(`/survey/${survey.id}/email`)
                    }
                }
                break
            case 'print':
                component = (
                    <AccessRights
                        store={store}
                        deniedRedirect="/home/e/0106.1"
                        customRule={this.printAccess}
                    >
                        <Print store={store} match={match} history={history} />
                    </AccessRights>
                )
                break
            case 'preview':
                if (store.surveyAuthLevel[1] < 3) {
                    location.href = '/home/e/0106.1'
                    return <div />
                }
                if (survey.metadata.taxonomy.surveyType === 'EM' && !store.isTemplate) {
                    component = [
                        surveyTabsMenu,
                        <RouteNotAllowed store={store} surveyId={match.params.id} history={history} />,
                    ]
                } else {
                    component = [
                        surveyTabsMenu,
                        <Preview store={store} match={match} history={history} />,
                    ]
                }
                break
            case 'report':
                component = [
                    <AccessRights
                        store={store}
                        role="100|110|150"
                        customRule={this.hasReportAccess}
                        deniedRedirect="/home/e/0106.2"
                    >
                        {surveyTabsMenu}
                        {store.isTemplate
                            ? <RouteNotAllowed store={store} surveyId={match.params.id} history={history} />
                            : <Report store={store} match={match} history={history} />}
                    </AccessRights>,
                ]
                break
            case 'certification':
                component = [
                    surveyTabsMenu,
                    store.isTemplate
                        ? <RouteNotAllowed store={store} surveyId={match.params.id} history={history} />
                        : <Certification store={store} match={match} history={history} />,
                ]
                break
            case 'company':
                component = [
                    surveyTabsMenu,
                    store.isTemplate
                        ? <RouteNotAllowed store={store} surveyId={match.params.id} history={history} />
                        : <DynamicDashboard store={store} match={match} history={history} surveyDash />,
                ]
                break
            case 'presentation':
                if (survey.metadata.taxonomy.surveyType === 'EM' && !store.isTemplate) {
                    component = [
                        surveyTabsMenu,
                        <RouteNotAllowed store={store} surveyId={match.params.id} history={history} />,
                    ]
                } else {
                    component = [
                        <AccessRights
                            store={store}
                            role="100|110"
                            customRule={this.presentationAccess}
                            deniedRedirect="/home/e/0106.1"
                        >
                            {surveyTabsMenu}
                            {store.isTemplate
                                ? <RouteNotAllowed store={store} surveyId={match.params.id} history={history} />
                                : <PresentationV2 store={store} match={match} history={history} />}
                        </AccessRights>,
                    ]
                }
                break
            default:
                if (store.surveyAuthLevel[1] < 3) {
                    location.href = '/home/e/0106.1'
                    return <div />
                }
                component = [
                    surveyTabsMenu,
                    <Settings store={store} surveyId={match.params.id} history={history} isTemplate={store.isTemplate}/>,
                ]
        }
        return component
    }
}
